/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */
(function () {
  function updateCartDrawerCount(count) {
    document.querySelectorAll("[data-cart-drawer-count]").forEach(function (el) {
      el.textContent = count;
    });
  }

  function refreshCartDrawerCount() {
    return fetch("/cart.js", { credentials: "same-origin" })
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        updateCartDrawerCount(cart.item_count);
        return cart.item_count;
      })
      .catch(function () {});
  }

  var DISCOUNT_STORAGE_KEY = "cart-drawer-discount-code";

  function restoreCartDiscountInput() {
    var storedCode = sessionStorage.getItem(DISCOUNT_STORAGE_KEY);
    var discountInput = document.getElementById("cart-drawer-discount-code");

    if (storedCode && discountInput) {
      discountInput.value = storedCode;
    }
  }

  function showCartDiscountStatus(message, isError) {
    var status = document.getElementById("cart-drawer-discount-status");

    if (!status) {
      return;
    }

    status.textContent = message;
    status.hidden = !message;
    status.classList.toggle("CartDrawer__DiscountStatus--error", Boolean(isError));
  }

  function applyCartDiscountCode(code) {
    var redirectUrl = window.location.pathname + window.location.search;
    var discountUrl =
      "/discount/" +
      encodeURIComponent(code) +
      "?redirect=" +
      encodeURIComponent(redirectUrl);

    return fetch(discountUrl, {
      credentials: "same-origin",
      method: "GET",
    }).then(function (response) {
      sessionStorage.setItem(DISCOUNT_STORAGE_KEY, code);
      restoreCartDiscountInput();
      showCartDiscountStatus("Discount code applied");
      return response;
    }).catch(function () {
      showCartDiscountStatus("Unable to apply discount code", true);
    });
  }

  document.addEventListener("click", function (event) {
    var discountApply = event.target.closest('[data-action="apply-cart-discount"]');

    if (discountApply) {
      event.preventDefault();
      event.stopPropagation();

      var discountInput = document.getElementById("cart-drawer-discount-code");
      var code = discountInput ? discountInput.value.trim() : "";

      if (!code) {
        if (discountInput) {
          discountInput.focus();
        }
        return;
      }

      discountApply.disabled = true;
      discountApply.setAttribute("aria-busy", "true");

      applyCartDiscountCode(code).finally(function () {
        discountApply.disabled = false;
        discountApply.removeAttribute("aria-busy");
      });

      return;
    }

    var giftToggle = event.target.closest('[data-action="toggle-cart-gift"]');

    if (giftToggle) {
      event.preventDefault();
      event.stopPropagation();

      var giftGroup = giftToggle.closest(".CartDrawer__GiftToggle");
      var giftInput = giftGroup ? giftGroup.querySelector("[data-cart-gift-input]") : null;
      var isActive = giftToggle.getAttribute("aria-pressed") === "true";
      var nextState = !isActive;

      giftToggle.setAttribute("aria-pressed", nextState ? "true" : "false");

      if (giftInput) {
        giftInput.value = nextState ? "Yes" : "";
      }

      fetch("/cart/update.js", {
        body: JSON.stringify({
          attributes: {
            "This is a gift": nextState ? "Yes" : "",
          },
        }),
        credentials: "same-origin",
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Requested-With": "XMLHttpRequest",
        },
      });

      return;
    }

    var upsellOpenSize = event.target.closest('[data-action="open-cart-upsell-size"]');

    if (upsellOpenSize) {
      event.preventDefault();
      event.stopPropagation();
      openCartUpsellSizeModal(upsellOpenSize);
      return;
    }

    var freeGiftAdd = event.target.closest('[data-action="add-free-gift"]');

    if (freeGiftAdd) {
      event.preventDefault();
      event.stopPropagation();

      var giftVariantId = parseInt(freeGiftAdd.getAttribute("data-variant-id"), 10);

      if (!giftVariantId || freeGiftAdd.disabled) {
        return;
      }

      addFreeGiftVariant(giftVariantId, freeGiftAdd);
      return;
    }

    var upsellAdd = event.target.closest('[data-action="add-cart-upsell"]');

    if (upsellAdd) {
      event.preventDefault();
      event.stopPropagation();

      var variantId = parseInt(upsellAdd.getAttribute("data-variant-id"), 10);

      if (!variantId || upsellAdd.disabled) {
        return;
      }

      addCartUpsellVariant(variantId, upsellAdd);
      return;
    }

    var upsellConfirmSize = event.target.closest('[data-action="confirm-cart-upsell-size"]');

    if (upsellConfirmSize) {
      event.preventDefault();
      event.stopPropagation();

      if (!cartUpsellSizeModalState.selectedVariantId || upsellConfirmSize.disabled) {
        return;
      }

      addCartUpsellVariant(cartUpsellSizeModalState.selectedVariantId, upsellConfirmSize);
      return;
    }

    var upsellCloseSize = event.target.closest('[data-action="close-cart-upsell-size"]');

    if (upsellCloseSize) {
      event.preventDefault();
      event.stopPropagation();
      closeCartUpsellSizeModal();
      return;
    }
  });

  function addCartUpsellVariant(variantId, triggerButton, properties) {
    if (!variantId) {
      return;
    }

    if (triggerButton) {
      triggerButton.disabled = true;
      triggerButton.setAttribute("aria-busy", "true");
    }

    document.dispatchEvent(new CustomEvent("theme:loading:start"));

    fetch("/cart/add.js", {
      body: JSON.stringify({
        id: variantId,
        quantity: 1,
        properties: properties || {},
      }),
      credentials: "same-origin",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest",
      },
    })
      .then(function (response) {
        if (!response.ok) {
          throw new Error("Unable to add upsell item");
        }

        return response.json();
      })
      .then(function (addedItem) {
        closeCartUpsellSizeModal();
        document.dispatchEvent(
          new CustomEvent("product:added", {
            bubbles: true,
            detail: {
              variant: addedItem,
              quantity: 1,
            },
          })
        );
      })
      .catch(function () {
        if (triggerButton) {
          triggerButton.disabled = false;
          triggerButton.removeAttribute("aria-busy");
        }
        document.dispatchEvent(new CustomEvent("theme:loading:end"));
      });
  }

  /**
   * Free gifts (cart page). A customer can hold one of each gift, never more, so an add is only
   * ever sent when the variant is not in the cart yet, and a gift left behind after its qualifying
   * product was removed is taken out again.
   */
  var FREE_GIFT_PROPERTIES = { _free_gift: "true" };
  var handledStaleFreeGiftKeys = {};

  function addFreeGiftVariant(variantId, triggerButton) {
    if (triggerButton) {
      triggerButton.disabled = true;
      triggerButton.setAttribute("aria-busy", "true");
    }

    fetch("/cart.js", { credentials: "same-origin" })
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        var alreadyInCart = (cart.items || []).some(function (item) {
          return item.variant_id === variantId;
        });

        if (alreadyInCart) {
          document.dispatchEvent(new CustomEvent("cart:updated", { detail: { itemCount: cart.item_count } }));
          return;
        }

        if (triggerButton) {
          triggerButton.disabled = false;
          triggerButton.removeAttribute("aria-busy");
        }

        addCartUpsellVariant(variantId, triggerButton, FREE_GIFT_PROPERTIES);
      })
      .catch(function () {
        if (triggerButton) {
          triggerButton.disabled = false;
          triggerButton.removeAttribute("aria-busy");
        }
      });
  }

  function removeStaleFreeGifts() {
    var container = document.querySelector("[data-free-gift-stale-keys]");

    if (!container) {
      return;
    }

    var staleKeys = (container.getAttribute("data-free-gift-stale-keys") || "")
      .split(",")
      .filter(Boolean);

    for (var i = 0; i < staleKeys.length; i++) {
      var staleKey = staleKeys[i];

      if (handledStaleFreeGiftKeys[staleKey]) {
        continue;
      }

      var removeLink = document.querySelector(
        '[data-action="remove-item"][data-line-id="' + staleKey + '"]'
      );

      if (!removeLink) {
        continue;
      }

      handledStaleFreeGiftKeys[staleKey] = true;

      // Removing re-renders the cart, which recalculates the remaining stale gifts.
      removeLink.click();
      return;
    }
  }

  var CART_UPSELL_SIZE_LABELS = ["size", "taille", "bröße", "tamanho", "tamaño", "koko", "サイズ"];
  var cartUpsellSizeModalState = {
    modal: null,
    triggerButton: null,
    selectedVariantId: null,
    product: null,
    sizeOptionIndex: null,
  };

  function getCartUpsellSizeModal() {
    cartUpsellSizeModalState.modal = document.getElementById("cart-upsell-size-modal");
    return cartUpsellSizeModalState.modal;
  }

  function isCartUpsellSizeModalOpen() {
    var modal = getCartUpsellSizeModal();
    return Boolean(modal && modal.classList.contains("is-open"));
  }

  function getCartUpsellSizeOptionIndex(product) {
    if (!product || !product.options || !product.options.length) {
      return null;
    }

    for (var i = 0; i < product.options.length; i++) {
      var option = product.options[i];
      var optionName = "";

      if (typeof option === "string") {
        optionName = option;
      } else if (option && option.name) {
        optionName = option.name;
      }

      optionName = String(optionName).toLowerCase().trim();

      if (CART_UPSELL_SIZE_LABELS.indexOf(optionName) !== -1) {
        return i + 1;
      }

      for (var j = 0; j < CART_UPSELL_SIZE_LABELS.length; j++) {
        if (optionName.indexOf(CART_UPSELL_SIZE_LABELS[j]) !== -1) {
          return i + 1;
        }
      }
    }

    if (product.options.length === 1 && product.variants && product.variants.length > 1) {
      return 1;
    }

    return null;
  }

  function parseCartUpsellProductVariants(triggerButton) {
    var variantsJson = triggerButton.getAttribute("data-product-variants");
    var sizeOptionIndex = parseInt(triggerButton.getAttribute("data-size-option-position"), 10);

    if (!variantsJson || !sizeOptionIndex) {
      return null;
    }

    try {
      return {
        variants: JSON.parse(variantsJson),
        sizeOptionIndex: sizeOptionIndex,
      };
    } catch (error) {
      return null;
    }
  }

  function showCartUpsellSizeModal(modal) {
    modal.removeAttribute("hidden");
    modal.classList.add("is-open");
    modal.setAttribute("aria-hidden", "false");
  }

  function getVariantOptionValue(variant, optionIndex) {
    if (optionIndex === 1) {
      return variant.option1;
    }

    if (optionIndex === 2) {
      return variant.option2;
    }

    if (optionIndex === 3) {
      return variant.option3;
    }

    return "";
  }

  function findCartUpsellVariantForSize(product, sizeOptionIndex, sizeValue) {
    var availableVariant = null;
    var fallbackVariant = null;

    product.variants.forEach(function (variant) {
      if (getVariantOptionValue(variant, sizeOptionIndex) !== sizeValue) {
        return;
      }

      if (!fallbackVariant) {
        fallbackVariant = variant;
      }

      if (variant.available) {
        availableVariant = variant;
      }
    });

    return availableVariant || fallbackVariant;
  }

  function resetCartUpsellSizeModalSelection() {
    cartUpsellSizeModalState.selectedVariantId = null;

    var modal = getCartUpsellSizeModal();

    if (!modal) {
      return;
    }

    var confirmButton = modal.querySelector('[data-action="confirm-cart-upsell-size"]');
    var sizeButtons = modal.querySelectorAll("[data-upsell-size-option]");

    if (confirmButton) {
      confirmButton.disabled = true;
      confirmButton.removeAttribute("aria-busy");
    }

    sizeButtons.forEach(function (button) {
      button.classList.remove("is-selected");
      button.setAttribute("aria-selected", "false");
    });
  }

  function renderCartUpsellSizeOptions(product, sizeOptionIndexOverride) {
    var modal = getCartUpsellSizeModal();

    if (!modal) {
      return false;
    }

    var sizeList = modal.querySelector("[data-upsell-size-list]");
    var sizeOptionIndex = sizeOptionIndexOverride || getCartUpsellSizeOptionIndex(product);

    if (!sizeList || !sizeOptionIndex || !product || !product.variants || !product.variants.length) {
      if (sizeList) {
        sizeList.innerHTML = "";
      }
      return false;
    }

    cartUpsellSizeModalState.sizeOptionIndex = sizeOptionIndex;
    sizeList.innerHTML = "";

    var seenSizes = {};
    var sizeValues = [];

    product.variants.forEach(function (variant) {
      var sizeValue = getVariantOptionValue(variant, sizeOptionIndex);

      if (!sizeValue || seenSizes[sizeValue]) {
        return;
      }

      seenSizes[sizeValue] = true;
      sizeValues.push(sizeValue);
    });

    sizeValues.sort(function (a, b) {
      var aNumber = parseFloat(a);
      var bNumber = parseFloat(b);

      if (!isNaN(aNumber) && !isNaN(bNumber)) {
        return aNumber - bNumber;
      }

      return String(a).localeCompare(String(b));
    });

    sizeValues.forEach(function (sizeValue) {
      var matchedVariant = findCartUpsellVariantForSize(product, sizeOptionIndex, sizeValue);
      var isAvailable = matchedVariant && matchedVariant.available;
      var button = document.createElement("button");

      button.type = "button";
      button.className = "CartUpsellSizeModal__SizeOption";
      button.textContent = sizeValue;
      button.setAttribute("data-upsell-size-option", sizeValue);
      button.setAttribute("role", "option");
      button.setAttribute("aria-selected", "false");

      if (matchedVariant) {
        button.setAttribute("data-variant-id", String(matchedVariant.id));
      }

      if (!isAvailable) {
        button.disabled = true;
        button.classList.add("is-soldout");
      }

      sizeList.appendChild(button);
    });

    return sizeValues.length > 0;
  }

  function buildCartUpsellProductUrl(productHandle) {
    var root = getShopifyRoot();

    if (root.charAt(root.length - 1) !== "/") {
      root += "/";
    }

    return root + "products/" + encodeURIComponent(productHandle) + ".js";
  }

  function openCartUpsellSizeModal(triggerButton) {
    var modal = getCartUpsellSizeModal();
    var productHandle = triggerButton.getAttribute("data-product-handle");

    if (!modal || !productHandle || triggerButton.disabled) {
      return;
    }

    cartUpsellSizeModalState.triggerButton = triggerButton;
    resetCartUpsellSizeModalSelection();

    var title = modal.querySelector("[data-upsell-size-title]");
    var productTitle = triggerButton.getAttribute("data-product-title") || "";

    if (title) {
      title.textContent = productTitle;
    }

    triggerButton.disabled = true;
    triggerButton.setAttribute("aria-busy", "true");

    function finishOpen(product, sizeOptionIndex) {
      cartUpsellSizeModalState.product = product;

      if (!renderCartUpsellSizeOptions(product, sizeOptionIndex)) {
        return;
      }

      showCartUpsellSizeModal(modal);

      var firstAvailable = modal.querySelector("[data-upsell-size-option]:not([disabled])");

      if (firstAvailable) {
        firstAvailable.focus();
      }
    }

    var embeddedProduct = parseCartUpsellProductVariants(triggerButton);

    if (embeddedProduct) {
      finishOpen(
        { variants: embeddedProduct.variants },
        embeddedProduct.sizeOptionIndex
      );
      triggerButton.disabled = false;
      triggerButton.removeAttribute("aria-busy");
      return;
    }

    fetch(buildCartUpsellProductUrl(productHandle), {
      credentials: "same-origin",
    })
      .then(function (response) {
        if (!response.ok) {
          throw new Error("Unable to load product");
        }

        return response.json();
      })
      .then(function (product) {
        finishOpen(product);
      })
      .catch(function () {})
      .finally(function () {
        if (triggerButton) {
          triggerButton.disabled = false;
          triggerButton.removeAttribute("aria-busy");
        }
      });
  }

  function closeCartUpsellSizeModal() {
    var modal = getCartUpsellSizeModal();

    if (!modal) {
      return;
    }

    modal.classList.remove("is-open");
    modal.setAttribute("aria-hidden", "true");
    modal.setAttribute("hidden", "");

    var sizeList = modal.querySelector("[data-upsell-size-list]");

    if (sizeList) {
      sizeList.innerHTML = "";
    }

    cartUpsellSizeModalState.product = null;
    cartUpsellSizeModalState.sizeOptionIndex = null;
    resetCartUpsellSizeModalSelection();

    if (cartUpsellSizeModalState.triggerButton) {
      cartUpsellSizeModalState.triggerButton.disabled = false;
      cartUpsellSizeModalState.triggerButton.removeAttribute("aria-busy");
      cartUpsellSizeModalState.triggerButton = null;
    }
  }

  document.addEventListener("click", function (event) {
    var sizeOption = event.target.closest("[data-upsell-size-option]");

    if (!sizeOption || sizeOption.disabled) {
      return;
    }

    var modal = getCartUpsellSizeModal();

    if (!modal || !modal.classList.contains("is-open")) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();

    var variantId = parseInt(sizeOption.getAttribute("data-variant-id"), 10);

    if (!variantId) {
      return;
    }

    modal.querySelectorAll("[data-upsell-size-option]").forEach(function (button) {
      var isSelected = button === sizeOption;
      button.classList.toggle("is-selected", isSelected);
      button.setAttribute("aria-selected", isSelected ? "true" : "false");
    });

    cartUpsellSizeModalState.selectedVariantId = variantId;

    var confirmButton = modal.querySelector('[data-action="confirm-cart-upsell-size"]');

    if (confirmButton) {
      confirmButton.disabled = false;
    }
  });

  document.addEventListener("keyup", function (event) {
    if (event.key !== "Escape" && event.keyCode !== 27) {
      return;
    }

    if (!isCartUpsellSizeModalOpen()) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();
    closeCartUpsellSizeModal();
  }, true);

  document.addEventListener("click", function (event) {
    if (
      event.target.closest('[data-action="close-drawer"][data-drawer-id="sidebar-cart"]') ||
      (event.target.classList && event.target.classList.contains("PageOverlay"))
    ) {
      closeCartUpsellSizeModal();
    }
  });

  document.addEventListener("keydown", function (event) {
    if (event.key !== "Enter" || !event.target.matches("#cart-drawer-discount-code")) {
      return;
    }

    event.preventDefault();

    var discountApply = document.querySelector('[data-action="apply-cart-discount"]');
    if (discountApply) {
      discountApply.click();
    }
  });

  function syncSawCartFromDrawer() {
    var sawDataEl = document.getElementById("saw-cart-data");

    if (!sawDataEl) {
      return Promise.resolve(false);
    }

    try {
      window.saw_cart = JSON.parse(sawDataEl.textContent);
      return Promise.resolve(true);
    } catch (error) {
      return Promise.resolve(false);
    }
  }

  function fetchSawCartFromDrawerView() {
    return fetch("/cart?view=drawer&timestamp=" + Date.now(), { credentials: "same-origin" })
      .then(function (response) {
        return response.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, "text/html");
        var sawDataEl = doc.getElementById("saw-cart-data");

        if (!sawDataEl) {
          return false;
        }

        window.saw_cart = JSON.parse(sawDataEl.textContent);
        return true;
      });
  }

  function refreshSawCartCheck() {
    if (typeof window.SAWCartCheck !== "function") {
      return;
    }

    syncSawCartFromDrawer()
      .then(function (syncedFromDrawer) {
        if (syncedFromDrawer) {
          window.SAWCartCheck();
          return;
        }

        return fetchSawCartFromDrawerView().then(function (syncedFromView) {
          if (syncedFromView) {
            window.SAWCartCheck();
            return;
          }

          return fetch("/cart.js", { credentials: "same-origin" })
            .then(function (response) {
              return response.json();
            })
            .then(function (cart) {
              window.saw_cart = cart;
              window.SAWCartCheck();
            });
        });
      })
      .catch(function () {
        window.SAWCartCheck();
      });
  }

  var cartDrawerUpsellRequestId = 0;
  var cartDrawerUpsellLoadTimer;
  var cartDrawerUpsellPriorityProductId = null;
  var CART_DRAWER_UPSELL_FETCH_LIMIT = 10;

  function getShopifyRoot() {
    return window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root
      : "/";
  }

  function getCartDrawerUpsellElements() {
    // The same block is used by the drawer and by the full page cart, which are never both rendered.
    var upsell = document.querySelector(
      "#sidebar-cart [data-cart-drawer-upsell], [data-cart-page] [data-cart-drawer-upsell]"
    );

    if (!upsell) {
      return null;
    }

    return {
      upsell: upsell,
      list: upsell.querySelector(".CartDrawer__UpsellList"),
    };
  }

  function fetchCartDrawerRecommendationsSection(productId, sectionId, limit) {
    var url =
      getShopifyRoot() +
      "recommendations/products?section_id=" +
      encodeURIComponent(sectionId) +
      "&product_id=" +
      encodeURIComponent(productId) +
      "&limit=" +
      encodeURIComponent(limit) +
      "&intent=related";

    return fetch(url, { credentials: "same-origin" }).then(function (response) {
      if (!response.ok) {
        throw new Error("Unable to load recommendation section");
      }

      return response.text();
    });
  }

  function collectCartDrawerRecommendationItems(productId, sectionId, limit, cartProductIds, seenProductIds, collectedItems, displayLimit) {
    if (collectedItems.length >= displayLimit) {
      return Promise.resolve();
    }

    return fetchCartDrawerRecommendationsSection(productId, sectionId, limit)
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, "text/html");
        var recommendationsRoot = doc.querySelector("[data-cart-upsell-recommendations]");

        if (!recommendationsRoot) {
          return;
        }

        var items = recommendationsRoot.querySelectorAll("[data-cart-upsell-item]");

        items.forEach(function (item) {
          if (collectedItems.length >= displayLimit) {
            return;
          }

          var recommendedProductId = item.getAttribute("data-product-id");

          if (
            !recommendedProductId ||
            cartProductIds[recommendedProductId] ||
            seenProductIds[recommendedProductId]
          ) {
            return;
          }

          seenProductIds[recommendedProductId] = true;
          collectedItems.push(document.importNode(item, true));
        });
      })
      .catch(function () {});
  }

  function renderCartDrawerUpsells(collectedItems, requestId) {
    if (requestId !== cartDrawerUpsellRequestId) {
      return;
    }

    var elements = getCartDrawerUpsellElements();

    if (!elements || !elements.list) {
      return;
    }

    elements.list.innerHTML = "";

    if (collectedItems.length === 0) {
      elements.upsell.hidden = true;
      return;
    }

    collectedItems.forEach(function (item) {
      elements.list.appendChild(item);
    });

    elements.upsell.hidden = false;

    if (window.theme && window.theme.currencyConversionEnabled && window.Currency) {
      window.Currency.convertAll(elements.list);
    }
  }

  function getCartDrawerUpsellAnchorProductId(cart, priorityProductId) {
    if (priorityProductId) {
      return priorityProductId;
    }

    if (!cart.items || cart.items.length === 0) {
      return null;
    }

    return cart.items[cart.items.length - 1].product_id;
  }

  function loadCartDrawerUpsells(retryCount) {
    retryCount = retryCount || 0;
    var elements = getCartDrawerUpsellElements();

    if (!elements || !elements.list) {
      if (retryCount < 6) {
        return new Promise(function (resolve) {
          setTimeout(function () {
            loadCartDrawerUpsells(retryCount + 1).then(resolve);
          }, 250);
        });
      }

      return Promise.resolve();
    }

    var upsell = elements.upsell;
    var sectionId = upsell.getAttribute("data-upsell-section-id") || "cart-drawer-upsell-recommendations";
    var displayLimit = parseInt(upsell.getAttribute("data-upsell-display-limit") || "4", 10);
    var priorityProductId = cartDrawerUpsellPriorityProductId;
    cartDrawerUpsellPriorityProductId = null;

    var requestId = ++cartDrawerUpsellRequestId;

    return fetch("/cart.js", { credentials: "same-origin" })
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        if (requestId !== cartDrawerUpsellRequestId) {
          return;
        }

        var anchorProductId = getCartDrawerUpsellAnchorProductId(cart, priorityProductId);

        if (!anchorProductId) {
          upsell.hidden = true;
          return;
        }

        var cartProductIds = {};
        cart.items.forEach(function (item) {
          cartProductIds[String(item.product_id)] = true;
        });

        var seenProductIds = {};
        var collectedItems = [];

        return collectCartDrawerRecommendationItems(
          anchorProductId,
          sectionId,
          CART_DRAWER_UPSELL_FETCH_LIMIT,
          cartProductIds,
          seenProductIds,
          collectedItems,
          displayLimit
        ).then(function () {
          renderCartDrawerUpsells(collectedItems, requestId);
        });
      })
      .catch(function () {
        if (requestId === cartDrawerUpsellRequestId) {
          var fallbackElements = getCartDrawerUpsellElements();
          if (fallbackElements && fallbackElements.upsell) {
            fallbackElements.upsell.hidden = true;
          }
        }
      });
  }

  function scheduleLoadCartDrawerUpsells(delay) {
    clearTimeout(cartDrawerUpsellLoadTimer);
    cartDrawerUpsellLoadTimer = setTimeout(loadCartDrawerUpsells, delay);
  }

  function getCartRoots() {
    return [document.getElementById("sidebar-cart"), document.querySelector("[data-cart-page]")].filter(
      Boolean
    );
  }

  function bindCartDrawerUpsellRerenderObserver() {
    getCartRoots().forEach(function (cartRoot) {
      if (cartRoot.dataset.cartDrawerUpsellObserver === "true") {
        return;
      }

      cartRoot.dataset.cartDrawerUpsellObserver = "true";

      var observer = new MutationObserver(function (mutations) {
        for (var i = 0; i < mutations.length; i++) {
          var mutation = mutations[i];

          if (mutation.type !== "childList") {
            continue;
          }

          for (var j = 0; j < mutation.addedNodes.length; j++) {
            var node = mutation.addedNodes[j];

            if (node.nodeType === 1 && node.classList && node.classList.contains("Cart")) {
              scheduleLoadCartDrawerUpsells(50);
              removeStaleFreeGifts();
              return;
            }
          }
        }
      });

      observer.observe(cartRoot, { childList: true, subtree: true });
    });
  }

  document.addEventListener("product:added", function (event) {
    var variant = event.detail && event.detail.variant;

    if (variant && variant.product_id) {
      cartDrawerUpsellPriorityProductId = variant.product_id;
    }

    refreshCartDrawerCount();
    setTimeout(function () {
      refreshSawCartCheck();
    }, 700);
    scheduleLoadCartDrawerUpsells(900);
  });

  document.addEventListener("cart:updated", function (event) {
    closeCartUpsellSizeModal();
    cartUpsellSizeModalState.modal = null;

    if (event.detail && typeof event.detail.itemCount === "number") {
      updateCartDrawerCount(event.detail.itemCount);
    }

    restoreCartDiscountInput();
    setTimeout(function () {
      refreshSawCartCheck();
    }, 150);
    scheduleLoadCartDrawerUpsells(900);
  });

  function bindSidebarCartListeners() {
    getCartRoots().forEach(function (cartRoot) {
      if (cartRoot.dataset.cartDrawerCountBound === "true") {
        return;
      }

      cartRoot.dataset.cartDrawerCountBound = "true";

      cartRoot.addEventListener("click", function (event) {
        if (!event.target.closest('[data-action="update-item-quantity"], [data-action="remove-item"]')) {
          return;
        }

        setTimeout(function () {
          refreshCartDrawerCount();
          refreshSawCartCheck();
        }, 700);
        scheduleLoadCartDrawerUpsells(900);
      });

      cartRoot.addEventListener("change", function (event) {
        if (!event.target.matches(".QuantitySelector__CurrentQuantity")) {
          return;
        }

        setTimeout(function () {
          refreshCartDrawerCount();
          refreshSawCartCheck();
        }, 700);
        scheduleLoadCartDrawerUpsells(900);
      });
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      bindSidebarCartListeners();
      bindCartDrawerUpsellRerenderObserver();
      scheduleLoadCartDrawerUpsells(0);
      removeStaleFreeGifts();
    });
  } else {
    bindSidebarCartListeners();
    bindCartDrawerUpsellRerenderObserver();
    scheduleLoadCartDrawerUpsells(0);
    removeStaleFreeGifts();
  }

  restoreCartDiscountInput();

  window.syncSawCartFromDrawer = syncSawCartFromDrawer;
  window.refreshSawCartCheck = refreshSawCartCheck;
  window.loadCartDrawerUpsells = loadCartDrawerUpsells;
})();

document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".Rte iframe").forEach(function (iframe) {
    if (Number(iframe.width) >= Number(iframe.height)) return;
    if (
      iframe.src.indexOf("youtube") !== -1 ||
      iframe.src.indexOf("youtu.be") !== -1 ||
      iframe.src.indexOf("vimeo") !== -1
    ) {
      setTimeout(() => {
        const iframeParent = iframe.parentElement;
        if (iframeParent.classList.contains("VideoWrapper")) {
          iframeParent.classList.add("VideoWrapper--portrait");
        } else {
          iframe.outerHTML = '<div class="VideoWrapper VideoWrapper--portrait">' + iframe.outerHTML + "</div>";
          // Re-set the src attribute on each iframe after page load for Chrome's "incorrect iFrame content on 'back'" bug.
          // https://code.google.com/p/chromium/issues/detail?id=395791. Need to specifically target video and admin bar
          iframe.src = iframe.src;
        }
      }, 200);
    }
  });
});

$(function () {
  $(".fadein .fadein--item:gt(0)").hide();
  setInterval(function () {
    $(".fadein--item:first-child").fadeOut().next(".fadein--item").fadeIn().end().appendTo(".fadein");
  }, 3000);

  const isPdp = $("body").attr("class").includes("template-product");

  if (isPdp) {
    const vids = document.querySelectorAll(".ImageVideoWrapper iframe");
    vids.forEach((vid) => {
      const player = new Vimeo.Player(vid);
      vid.parentElement.addEventListener("click", () => {
        player
          .getPaused()
          .then((paused) => (paused ? player.play() : player.pause()))
          .catch((err) => console.log(err));
      });
    });
  }
});

/* Some functions / components brought over from Slate for Native Filtering */

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector("details");

    this.addEventListener("keyup", this.onKeyUp.bind(this));
    this.addEventListener("focusout", this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll("summary").forEach((summary) =>
      summary.addEventListener("click", this.onSummaryClick.bind(this))
    );
    this.querySelectorAll(
      "button:not(.localization-selector):not(.country-selector__close-button):not(.country-filter__reset-button)"
    ).forEach((button) => button.addEventListener("click", this.onCloseButtonClick.bind(this)));
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== "ESCAPE") return;

    const openDetailsElement = event.target.closest("details[open]");
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector("summary"))
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest(".has-submenu");
    const isOpen = detailsElement.hasAttribute("open");
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector("button"));
      summaryElement.nextElementSibling.removeEventListener("transitionend", addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia("(max-width: 990px)")) {
        document.documentElement.style.setProperty("--viewport-height", `${window.innerHeight}px`);
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add("menu-opening");
        summaryElement.setAttribute("aria-expanded", true);
        parentMenuElement && parentMenuElement.classList.add("submenu-open");
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener("transitionend", addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });
    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove("menu-opening");
    this.mainDetailsToggle.querySelectorAll("details").forEach((details) => {
      details.removeAttribute("open");
      details.classList.remove("menu-opening");
    });
    this.mainDetailsToggle.querySelectorAll(".submenu-open").forEach((submenu) => {
      submenu.classList.remove("submenu-open");
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);

    if (event instanceof KeyboardEvent) elementToFocus?.setAttribute("aria-expanded", false);
  }

  onFocusOut() {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute("open") && !this.mainDetailsToggle.contains(document.activeElement))
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest("details");
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest(".submenu-open");
    parentMenuElement && parentMenuElement.classList.remove("submenu-open");
    detailsElement.classList.remove("menu-opening");
    detailsElement.querySelector("summary").setAttribute("aria-expanded", false);
    removeTrapFocus(detailsElement.querySelector("summary"));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 200) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute("open");
        if (detailsElement.closest("details[open]")) {
          trapFocus(detailsElement.closest("details[open]"), detailsElement.querySelector("summary"));
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define("menu-drawer", MenuDrawer);

/**
 * Hide page-transition overlay when the setting is off.
 * Dev preview can serve stale CSS (compiled with transitions on) while
 * settings_data has show_page_transition: false, leaving a full-screen veil.
 */
(function () {
  function dismissPageTransition() {
    if (window.theme && window.theme.showPageTransition) return;
    var overlay = document.querySelector(".PageTransition");
    if (!overlay) return;
    overlay.style.display = "none";
    overlay.style.visibility = "hidden";
    overlay.style.opacity = "0";
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", dismissPageTransition);
  } else {
    dismissPageTransition();
  }
})();

/**
 * NAV-01 / NAV-02: Mobile accordion navigation
 */
(function () {
  function initMobileNavAccordion() {
    var mobileNav = document.getElementById("mobile-nav");
    if (!mobileNav) return;

    mobileNav.querySelectorAll('[data-mobile-accordion="lvl1"]').forEach(function (btn) {
      btn.addEventListener("click", function () {
        var item = btn.closest("[data-mobile-nav-lvl1]");
        if (!item) return;
        var isOpen = item.classList.contains("is-open");
        mobileNav.querySelectorAll("[data-mobile-nav-lvl1].is-open").forEach(function (el) {
          el.classList.remove("is-open");
          var toggle = el.querySelector('[data-mobile-accordion="lvl1"]');
          if (toggle) toggle.setAttribute("aria-expanded", "false");
        });
        if (!isOpen) {
          item.classList.add("is-open");
          btn.setAttribute("aria-expanded", "true");
        }
      });
    });

    mobileNav.querySelectorAll('[data-mobile-accordion="lvl2"]').forEach(function (btn) {
      btn.addEventListener("click", function () {
        var item = btn.closest("[data-mobile-nav-lvl2]");
        if (!item) return;
        var isOpen = item.classList.toggle("is-open");
        btn.setAttribute("aria-expanded", isOpen ? "true" : "false");
      });
    });
  }

  function syncMobileNavState() {
    var menuToggle = document.getElementById("menu");
    var mobileNav = document.getElementById("mobile-nav");
    if (!menuToggle || !mobileNav) return;

    function updateAria() {
      mobileNav.setAttribute("aria-hidden", menuToggle.checked ? "false" : "true");
      if (!menuToggle.checked) {
        mobileNav.querySelectorAll(".is-open").forEach(function (el) {
          el.classList.remove("is-open");
        });
        mobileNav.querySelectorAll("[aria-expanded='true']").forEach(function (el) {
          el.setAttribute("aria-expanded", "false");
        });
      }
    }

    menuToggle.addEventListener("change", updateAria);
    updateAria();

    // The open/close controls are <label> elements (checkbox hack), so they are
    // not natively keyboard-operable. Toggle the checkbox on Space/Enter.
    document.querySelectorAll(".menu-toggle, .MobileNav__Close").forEach(function (toggle) {
      if (toggle.dataset.keyboardBound === "true") return;
      toggle.dataset.keyboardBound = "true";
      toggle.addEventListener("keydown", function (event) {
        if (event.key === " " || event.key === "Enter") {
          event.preventDefault();
          menuToggle.checked = !menuToggle.checked;
          menuToggle.dispatchEvent(new Event("change"));
        }
      });
    });
  }

  function initMobileNav() {
    initMobileNavAccordion();
    syncMobileNavState();

    document.addEventListener("shopify:section:load", function (event) {
      if (event.target.querySelector && (event.target.querySelector("#mobile-nav") || event.target.querySelector(".Header--collection-nav"))) {
        initMobileNavAccordion();
        syncMobileNavState();
      }
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initMobileNav);
  } else {
    initMobileNav();
  }
})();

/**
 * HS-50: open desktop megamenu when hovering the nav word.
 * Prestige only opens when event.target is the LI itself, so hovering
 * the inner <a> (the label) is ignored and the underline/gap is what fires.
 */
(function () {
  function openDesktopNavItem(item) {
    if (!item || item.classList.contains("is-expanded")) return;

    item.classList.add("is-expanded");
    item.querySelectorAll(":scope > .MegaMenu").forEach(function (menu) {
      menu.setAttribute("aria-hidden", "false");
    });

    item.parentElement.querySelectorAll(".HorizontalList__Item.is-expanded").forEach(function (el) {
      if (el === item) return;
      el.classList.remove("is-expanded");
      el.querySelectorAll(":scope > .MegaMenu").forEach(function (menu) {
        menu.setAttribute("aria-hidden", "true");
      });
    });
  }

  function syncMegamenuOpenBodyClass() {
    var openMenu = document.querySelector('.Header__MainNav .MegaMenu[aria-hidden="false"]');
    document.body.classList.toggle("megamenu-open", !!openMenu);
  }

  function bindMegamenuOpenObserver() {
    var header = document.querySelector(".shopify-section--header");
    if (!header || header.dataset.megamenuOpenObserver === "true") {
      return;
    }

    header.dataset.megamenuOpenObserver = "true";

    new MutationObserver(syncMegamenuOpenBodyClass).observe(header, {
      subtree: true,
      attributes: true,
      attributeFilter: ["aria-hidden", "class"],
    });

    syncMegamenuOpenBodyClass();
  }

  function findMegamenuLinkAtPoint(x, y) {
    var menus = document.querySelectorAll(".Header__MainNav .MegaMenu[aria-hidden=\"false\"]");
    if (!menus.length) {
      return null;
    }

    for (var m = 0; m < menus.length; m++) {
      var links = menus[m].querySelectorAll('a[href]:not([href=""])');
      for (var i = 0; i < links.length; i++) {
        var link = links[i];
        var rect = link.getBoundingClientRect();
        if (!rect.width || !rect.height) {
          continue;
        }
        if (x >= rect.left && x <= rect.right && y >= rect.top && y <= rect.bottom) {
          return link;
        }
      }
    }

    return null;
  }

  function getMegamenuLinkFromEvent(event) {
    if (event.target && event.target.closest) {
      var direct = event.target.closest('.Header__MainNav .MegaMenu a[href]:not([href=""])');
      if (direct) {
        return direct;
      }
    }

    return findMegamenuLinkAtPoint(event.clientX, event.clientY);
  }

  function isCartDrawerOpen() {
    var drawer = document.getElementById("sidebar-cart");
    return drawer && drawer.getAttribute("aria-hidden") === "false";
  }

  function isDesktopMegamenuOpen() {
    return !!document.querySelector('.Header__MainNav .MegaMenu[aria-hidden="false"]');
  }

  /**
   * Prestige traps focus inside an open drawer. Megamenu links sit outside #sidebar-cart,
   * so focusin on a link immediately yanks focus back to the drawer and breaks navigation.
   */
  function bindDrawerFocusTrapMegamenuBypass() {
    if (document.documentElement.dataset.megamenuFocusBypassBound === "true") {
      return;
    }

    document.documentElement.dataset.megamenuFocusBypassBound = "true";

    document.addEventListener(
      "focusin",
      function (event) {
        if (!isCartDrawerOpen()) {
          return;
        }

        if (event.target && event.target.closest && event.target.closest(".Header__MainNav .MegaMenu")) {
          event.stopImmediatePropagation();
        }
      },
      true
    );
  }

  /**
   * Prestige closes all nav on .Header mouseleave. The megamenu panel sits below the
   * header box, so moving into it can fire mouseleave and collapse the menu before
   * the link click — especially with the cart drawer open.
   */
  function bindHeaderMouseleaveGuard() {
    var header = document.querySelector(".shopify-section--header .Header");
    if (!header || header.dataset.mouseleaveGuardBound === "true") {
      return;
    }

    header.dataset.mouseleaveGuardBound = "true";

    var guard = function (event) {
      if (event.target !== header) {
        return;
      }

      var related = event.relatedTarget;

      if (related && related.closest) {
        if (related.closest(".MegaMenu") || related.closest("#sidebar-cart")) {
          event.stopImmediatePropagation();
          return;
        }
      }

      if (isCartDrawerOpen() && isDesktopMegamenuOpen()) {
        event.stopImmediatePropagation();
      }
    };

    header.addEventListener("mouseleave", guard, true);
  }

  function handleMegamenuNavWithCartOpen(event) {
    if (event.button !== 0) {
      return;
    }

    if (event.defaultPrevented || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) {
      return;
    }

    if (!isCartDrawerOpen()) {
      return;
    }

    var link = getMegamenuLinkFromEvent(event);
    if (!link) {
      return;
    }

    event.preventDefault();
    event.stopImmediatePropagation();
    window.location.assign(link.href);
  }

  function bindMegamenuLinkClickThrough() {
    if (document.documentElement.dataset.megamenuClickThroughBound === "true") {
      return;
    }

    document.documentElement.dataset.megamenuClickThroughBound = "true";

    document.addEventListener("mousedown", handleMegamenuNavWithCartOpen, true);
  }

  /** Do not close the cart drawer when the dimmed overlay is clicked while using the megamenu. */
  function bindCartDrawerOverlayGuard() {
    var overlay = document.querySelector(".PageOverlay");
    if (!overlay || overlay.dataset.megamenuGuardBound === "true") {
      return;
    }

    overlay.dataset.megamenuGuardBound = "true";

    overlay.addEventListener(
      "click",
      function (event) {
        if (document.body.classList.contains("megamenu-open") || isDesktopMegamenuOpen()) {
          event.stopImmediatePropagation();
          return;
        }

        if (isCartDrawerOpen() && findMegamenuLinkAtPoint(event.clientX, event.clientY)) {
          event.stopImmediatePropagation();
        }
      },
      true
    );
  }

  function initDesktopNavWordHover() {
    var nav = document.querySelector(".Header__MainNav");
    if (!nav || nav.dataset.wordHoverBound === "true") return;
    nav.dataset.wordHoverBound = "true";

    nav.addEventListener("mouseover", function (event) {
      var item = event.target.closest(".HorizontalList__Item");
      if (!item || !nav.contains(item) || !item.hasAttribute("aria-haspopup")) return;
      openDesktopNavItem(item);
      syncMegamenuOpenBodyClass();
    });
  }

  function initDesktopMegamenuCartFix() {
    initDesktopNavWordHover();
    bindMegamenuOpenObserver();
    bindDrawerFocusTrapMegamenuBypass();
    bindHeaderMouseleaveGuard();
    bindMegamenuLinkClickThrough();
    bindCartDrawerOverlayGuard();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initDesktopMegamenuCartFix);
  } else {
    initDesktopMegamenuCartFix();
  }

  document.addEventListener("shopify:section:load", initDesktopMegamenuCartFix);
})();

/**
 * PDP-08: Kill legacy Prestige sticky/OverflowScroller behaviour that sets
 * Product__Info { top: -NNNNPx } while scrolling.
 */
(function () {
  function clearPdpScrollLocks() {
    var info = document.querySelector(".Product__Info");
    var aside = document.querySelector(".Product__Aside");
    var wrapper = document.querySelector(".Product__InfoWrapper");
    var productWrapper = document.querySelector(".Product__Wrapper");

    if (!info || !aside || !info.contains(aside)) return;

    info.style.top = "";
    info.style.bottom = "";
    aside.style.minHeight = "";
    if (wrapper) wrapper.style.maxHeight = "";
    if (productWrapper) productWrapper.style.minHeight = "";
  }

  function bindPdpScrollLockClear() {
    clearPdpScrollLocks();
    if (window.__habbotPdpScrollLockBound) return;
    window.__habbotPdpScrollLockBound = true;
    window.addEventListener("scroll", clearPdpScrollLocks, { passive: true });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", bindPdpScrollLockClear);
  } else {
    bindPdpScrollLockClear();
  }

  window.addEventListener("load", clearPdpScrollLocks);
  document.addEventListener("breakpoint:changed", function () {
    setTimeout(clearPdpScrollLocks, 0);
  });
})();

/**
 * PDP-08: Size system toggle (EU / AU-US / UK / JP-CM)
 * Labels only — Shopify variants remain EU sizes.
 * Conversion table from Habbot size guide.
 */
(function () {
  var SIZE_MAP = {
    "34": { EU: "34", AU_US: "3-3.5", UK: "1", CM: "21.6" },
    "35": { EU: "35", AU_US: "4-4.5", UK: "2", CM: "22.2" },
    "36": { EU: "36", AU_US: "5-5.5", UK: "3", CM: "22.8" },
    "37": { EU: "37", AU_US: "6-6.5", UK: "4", CM: "23.4" },
    "38": { EU: "38", AU_US: "7-7.5", UK: "5", CM: "24" },
    "39": { EU: "39", AU_US: "8-8.5", UK: "6", CM: "24.6" },
    "40": { EU: "40", AU_US: "9-9.5", UK: "7", CM: "25.2" },
    "41": { EU: "41", AU_US: "10-10.5", UK: "8", CM: "25.8" },
    "42": { EU: "42", AU_US: "11-11.5", UK: "9", CM: "26.5" },
    "43": { EU: "43", AU_US: "12-12.5", UK: "10", CM: "27.1" }
  };

  function applySystem(root, system) {
    var labels = root.querySelectorAll(".SizeSwatch[data-eu-size]");
    var wide = system === "AU_US" || system === "CM";
    root.classList.toggle("is-wide-sizes", wide);

    labels.forEach(function (label) {
      var eu = String(label.getAttribute("data-eu-size") || "").trim();
      var mapped = SIZE_MAP[eu];
      label.textContent = mapped && mapped[system] != null ? mapped[system] : eu;
    });
  }

  function initSizeSystemToggle(scope) {
    var roots = (scope || document).querySelectorAll("[data-size-system-toggle]");
    roots.forEach(function (toggle) {
      if (toggle.dataset.bound === "true") return;
      toggle.dataset.bound = "true";

      var option = toggle.closest(".ProductForm__Option") || toggle.parentElement;
      toggle.addEventListener("click", function (event) {
        var btn = event.target.closest("[data-system]");
        if (!btn) return;

        toggle.querySelectorAll("[data-system]").forEach(function (el) {
          el.classList.toggle("is-active", el === btn);
          el.setAttribute("aria-pressed", el === btn ? "true" : "false");
        });

        applySystem(option, btn.getAttribute("data-system"));
      });
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      initSizeSystemToggle(document);
    });
  } else {
    initSizeSystemToggle(document);
  }

  document.addEventListener("shopify:section:load", function (event) {
    initSizeSystemToggle(event.target);
  });
})();

/**
 * Mobile sticky add to cart bar (PDP-01). Restored for HS-45 client feedback.
 */
(function () {
  function initProductMobileStickyAtc() {
    try {
    var sticky = document.querySelector("[data-product-mobile-sticky]");
    if (!sticky || sticky.dataset.stickyInitialized === "true") return;
    sticky.dataset.stickyInitialized = "true";

    var productSection = sticky.closest("[data-section-type='product']");
    if (!productSection) return;

    var stickyCta = sticky.querySelector("[data-sticky-cta]");
    var stickyPrice = sticky.querySelector("[data-sticky-price]");
    var stickySize = sticky.querySelector("[data-sticky-size]");
    var stickyThumb = sticky.querySelector("[data-sticky-thumb]");
    var sizeLabels = ["size", "taille", "bröße", "tamanho", "tamaño", "koko", "サイズ"];
    var mobileQuery = window.matchMedia("(max-width: 1007px)");
    var observer = null;
    var isPastAtc = false;
    var overlayObserver = null;

    function getMainAddToCartButton() {
      return productSection.querySelector(".ProductForm__AddToCart");
    }

    function enforceDiscontinuedFinalState(variant) {
      if (productSection.getAttribute("data-product-discontinued-final") !== "true") return;
      if (variant === null) return;
      if (variant && variant.available) return;

      var mainButton = getMainAddToCartButton();
      if (!mainButton) return;

      var label = mainButton.querySelector("span");
      if (label) {
        label.textContent = window.languages.productFormSoldOut || "Sold Out";
      } else {
        mainButton.textContent = window.languages.productFormSoldOut || "Sold Out";
      }

      mainButton.removeAttribute("id");
      mainButton.removeAttribute("data-variant-id");
      mainButton.removeAttribute("data-action");
      mainButton.setAttribute("type", "button");
      mainButton.disabled = true;
    }

    function getSelectedSize() {
      var checkedSize = productSection.querySelector(".SizeSwatch__Radio:checked");
      if (checkedSize) return checkedSize.value;

      var selectedValues = productSection.querySelectorAll(".ProductForm__SelectedValue");
      for (var i = 0; i < selectedValues.length; i++) {
        var selectedValue = selectedValues[i];
        var option = selectedValue.closest(".ProductForm__Option");
        var label = option && option.querySelector(".ProductForm__Label");
        if (!label) continue;

        var optionName = label.textContent.replace(":", "").trim().toLowerCase();
        if (sizeLabels.indexOf(optionName) !== -1) {
          return selectedValue.textContent.trim();
        }
      }

      return "";
    }

    function updateStickySize() {
      if (!stickySize) return;

      var size = getSelectedSize();
      if (!size) {
        stickySize.hidden = true;
        stickySize.textContent = "";
        return;
      }

      stickySize.hidden = false;
      stickySize.textContent = " · " + size;
    }

    function updateStickyPrice() {
      if (!stickyPrice) return;

      var priceList = productSection.querySelector(".ProductMeta__PriceList");
      if (!priceList) return;

      var highlightPrice = priceList.querySelector(".Price--highlight");
      var regularPrice = priceList.querySelector(".ProductMeta__Price:not(.Price--compareAt):not(.ProductMeta__PriceLabel)");
      var priceElement = highlightPrice || regularPrice;

      if (!priceElement) return;

      var isSale = !!priceList.querySelector(".ProductMeta__Price.Price--compareAt");
      var priceClass = isSale
        ? "ProductMobileSticky__PriceValue ProductMobileSticky__PriceValue--sale"
        : "ProductMobileSticky__PriceValue";

      stickyPrice.innerHTML =
        '<span class="' + priceClass + '" data-money-convertible>' + priceElement.textContent.trim() + "</span>";
    }

    function updateStickyButton() {
      if (!stickyCta) return;

      var mainButton = getMainAddToCartButton();
      if (!mainButton) return;

      var labelSpan = mainButton.querySelector("span");
      var label = labelSpan ? labelSpan.textContent.trim() : mainButton.textContent.trim();
      stickyCta.textContent = label;

      if (mainButton.disabled) {
        stickyCta.disabled = true;
        stickyCta.removeAttribute("data-action");
        stickyCta.classList.remove("Button--primary", "Button--soldout");
        stickyCta.classList.add("Button--secondary");
      } else if (mainButton.id === "BIS_trigger") {
        stickyCta.disabled = false;
        stickyCta.removeAttribute("data-action");
        stickyCta.classList.remove("Button--primary", "Button--secondary");
        stickyCta.classList.add("Button--soldout");
      } else {
        stickyCta.disabled = false;
        stickyCta.setAttribute("data-action", "sticky-add-to-cart");
        stickyCta.classList.remove("Button--soldout", "Button--secondary");
        stickyCta.classList.add("Button--primary");
      }
    }

    function updateStickyImage(variant) {
      if (!stickyThumb || !variant || !variant.featured_image || !variant.featured_image.src) return;

      if (stickyThumb.tagName === "IMG") {
        stickyThumb.src = variant.featured_image.src;
      }
    }

    function isOverlayOpen() {
      return !!document.querySelector('.Drawer[aria-hidden="false"], .Modal[aria-hidden="false"], .Popover[aria-hidden="false"]');
    }

    function setStickyVisible(visible) {
      isPastAtc = visible;
      var shouldShow = visible && mobileQuery.matches && !isOverlayOpen();
      var isCurrentlyVisible = sticky.classList.contains("is-visible");
      var ariaHidden = sticky.getAttribute("aria-hidden") !== "false";
      var hasBodyClass = document.body.classList.contains("has-mobile-sticky-atc");

      if (isCurrentlyVisible === shouldShow && ariaHidden === !shouldShow && hasBodyClass === shouldShow) {
        return;
      }

      sticky.classList.toggle("is-visible", shouldShow);
      sticky.setAttribute("aria-hidden", shouldShow ? "false" : "true");
      document.body.classList.toggle("has-mobile-sticky-atc", shouldShow);
    }

    function bindVisibilityObserver() {
      if (observer) {
        observer.disconnect();
        observer = null;
      }

      var mainButton = getMainAddToCartButton();
      if (!mainButton || !mobileQuery.matches) {
        setStickyVisible(false);
        return;
      }

      observer = new IntersectionObserver(function (entries) {
        var entry = entries[0];
        setStickyVisible(!entry.isIntersecting);
      }, { threshold: 0, rootMargin: "0px 0px -1px 0px" });

      observer.observe(mainButton);
    }

    function scrollToSizeSelector() {
      var sizeSwatchList = productSection.querySelector(".SizeSwatchList");
      var sizeOption = sizeSwatchList && sizeSwatchList.closest(".ProductForm__Option");

      if (!sizeOption) {
        var labelEl = productSection.querySelector(".ProductForm__Option .ProductForm__Label");
        sizeOption = labelEl && labelEl.closest(".ProductForm__Option");
      }

      if (sizeOption) {
        sizeOption.scrollIntoView({ behavior: "smooth", block: "center" });
      }
    }

    if (stickyCta) {
      stickyCta.addEventListener("click", function () {
        var mainButton = getMainAddToCartButton();
        if (!mainButton || mainButton.disabled) return;
        mainButton.click();
      });
    }

    var stickyInfo = sticky.querySelector("[data-sticky-info]");
    if (stickyInfo) {
      stickyInfo.addEventListener("click", scrollToSizeSelector);
    }

    productSection.addEventListener("variant:changed", function (event) {
      enforceDiscontinuedFinalState(event.detail.variant);
      updateStickySize();
      updateStickyPrice();
      updateStickyButton();
      updateStickyImage(event.detail.variant);
      bindVisibilityObserver();
    });

    function bindOverlayObserver() {
      if (overlayObserver) {
        overlayObserver.disconnect();
        overlayObserver = null;
      }

      overlayObserver = new MutationObserver(function () {
        setStickyVisible(isPastAtc);
      });

      document.querySelectorAll(".Drawer, .Modal, .Popover").forEach(function (overlay) {
        overlayObserver.observe(overlay, {
          attributes: true,
          attributeFilter: ["aria-hidden", "class"]
        });
      });
    }

    function handleBreakpointChange() {
      bindVisibilityObserver();
      if (!mobileQuery.matches) {
        setStickyVisible(false);
      }
    }

    if (typeof mobileQuery.addEventListener === "function") {
      mobileQuery.addEventListener("change", handleBreakpointChange);
    } else if (typeof mobileQuery.addListener === "function") {
      mobileQuery.addListener(handleBreakpointChange);
    }

    updateStickySize();
    updateStickyPrice();
    updateStickyButton();
    bindOverlayObserver();
    bindVisibilityObserver();
    } catch (error) {
      console.error("Product mobile sticky ATC failed to initialize", error);
    }
  }

  function boot() {
    if (!document.body.classList.contains("template-product")) return;
    initProductMobileStickyAtc();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }

  document.addEventListener("shopify:section:load", function (event) {
    var sticky = event.target.querySelector("[data-product-mobile-sticky]");
    if (sticky) {
      sticky.dataset.stickyInitialized = "";
      initProductMobileStickyAtc();
    }
  });
})();

/**
 * HS-47: Re-measure the PDP Flickity gallery after zoom / resize.
 * Sudden jumps can fire before layout settles, so we refresh twice.
 */
(function () {
  var refreshTimer = null;
  var trailingTimer = null;
  var resizeObserver = null;
  var lastSlideshowWidth = -1;

  function getSlideshow() {
    return document.querySelector(".Product__Slideshow");
  }

  function getFlickity(slideshow) {
    if (!slideshow || typeof window.Flickity === "undefined") return null;
    return window.Flickity.data(slideshow);
  }

  function refreshProductCarousel() {
    var slideshow = getSlideshow();
    var flkty = getFlickity(slideshow);
    if (!flkty || !flkty.isActive) return;

    var index = flkty.selectedIndex;
    flkty.resize();
    if (typeof flkty.reposition === "function") flkty.reposition();
    if (typeof index === "number") flkty.select(index, false, true);
  }

  function runRefresh() {
    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(refreshProductCarousel);
    });
  }

  function scheduleRefresh() {
    if (refreshTimer) window.clearTimeout(refreshTimer);
    if (trailingTimer) window.clearTimeout(trailingTimer);

    refreshTimer = window.setTimeout(function () {
      refreshTimer = null;
      runRefresh();
    }, 50);

    trailingTimer = window.setTimeout(function () {
      trailingTimer = null;
      runRefresh();
    }, 400);
  }

  function observeSlideshow() {
    var slideshow = getSlideshow();
    if (!slideshow || !window.ResizeObserver) return;

    if (resizeObserver) resizeObserver.disconnect();

    lastSlideshowWidth = Math.round(slideshow.getBoundingClientRect().width);
    resizeObserver = new ResizeObserver(function (entries) {
      var width = Math.round((entries[0] && entries[0].contentRect && entries[0].contentRect.width) || 0);
      if (width === lastSlideshowWidth) return;
      lastSlideshowWidth = width;
      scheduleRefresh();
    });
    resizeObserver.observe(slideshow);
  }

  function bind() {
    if (!document.body.classList.contains("template-product")) return;
    if (window.__habbotPdpCarouselResizeBound) {
      observeSlideshow();
      scheduleRefresh();
      return;
    }
    window.__habbotPdpCarouselResizeBound = true;

    window.addEventListener("resize", scheduleRefresh);
    window.addEventListener("orientationchange", scheduleRefresh);
    if (window.visualViewport) {
      window.visualViewport.addEventListener("resize", scheduleRefresh);
    }
    document.addEventListener("breakpoint:changed", scheduleRefresh);

    observeSlideshow();
    scheduleRefresh();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", bind);
  } else {
    bind();
  }

  window.addEventListener("load", scheduleRefresh);

  document.addEventListener("shopify:section:load", function (event) {
    if (event.target && event.target.querySelector(".Product__Slideshow")) {
      bind();
    }
  });
})();
